/*************************************************/
/* HEADER                                        */
/*************************************************/

export function menu() {
    const parentMenuItemSelector = '.menu-nav__item--parent';
    const parentMenuItemParentSelector = '.menu-nav__item--parent';
    const submenuSelector = '.menu-nav--lvl-2';
    const parentMenuEnterEvents = ['focusin', 'mouseenter']
    const parentMenuExitEvents = ['focusout','mouseleave']

    const init = () => {
        const parentMenuItems = document.querySelectorAll(parentMenuItemSelector);
        if (parentMenuItems.length > 0) {
            parentMenuItems.forEach(item => {

                parentMenuEnterEvents.forEach(event => {
                    item.addEventListener(event, e => {
                        item.closest(parentMenuItemParentSelector).querySelector(submenuSelector)?.setAttribute('aria-hidden', false);
                    });
                });

                parentMenuExitEvents.forEach(event => {
                    item.addEventListener(event, e => {
                        item.closest(parentMenuItemParentSelector).querySelector(submenuSelector)?.setAttribute('aria-hidden', true);
                    });
                });

            });
        }
    };

    init();

}

